/**
 * Sprints360 — Mock data (UX-first, in-memory).
 * Backend real virá em fase separada. Toda mutação acontece via useReducer
 * no Sprints360Context, e este arquivo fornece apenas o estado inicial + helpers.
 */
import i18n from "@/i18n";


// ------------------ Defaults ------------------
export const ETAPAS_DEFAULT = [
  { nome: "Levantamento",     cor: "sky"     },
  { nome: "Definição",        cor: "indigo"  },
  { nome: "Desenvolvimento",  cor: "violet"  },
  { nome: "Testes Unitários", cor: "amber"   },
  { nome: "Testes Integrados",cor: "orange"  },
  { nome: "Implantação",      cor: "emerald" },
];

export const NIVEIS_PROFISSIONAL = ["Junior", "Pleno", "Sênior", "Expert"];

// horas produtivas por dia útil (usadas para calcular data_fim)
export const HORAS_POR_DIA_UTIL = 8;

// ------------------ Empresas mock (para vincular projetos) ------------------
export const EMPRESAS_MOCK = [];

// ------------------ Seeds de demonstração ------------------
// Jun/2026 — o projeto/atividades de exemplo foram removidos junto com a
// empresa de teste que os originava. O bucket DEMO agora nasce vazio; todo
// dado real vem do backend por workspace.
export const PROJETOS_INICIAIS = [];

// ------------------ Sprints / Etapas / Negócios / Atividades ------------------
export const SPRINTS_INICIAIS = [];
export const ETAPAS_INICIAIS = [];
export const NEGOCIOS_INICIAIS = [];
export const ATIVIDADES_INICIAIS = [];

// ------------------ Helpers de cálculo ------------------
export function calcDataFim(dataInicioISO, horas, horasPorDia = HORAS_POR_DIA_UTIL) {
  if (!dataInicioISO || !horas) return dataInicioISO;
  const dias = Math.max(1, Math.ceil(horas / horasPorDia));
  return addBusinessDays(dataInicioISO, dias - 1);
}

// Adiciona dias úteis (sem contar sáb/dom) — versão simples
export function addBusinessDays(iso, businessDays) {
  const d = new Date(iso);
  let added = 0;
  while (added < businessDays) {
    d.setDate(d.getDate() + 1);
    const wd = d.getDay();
    if (wd !== 0 && wd !== 6) added++;
  }
  return d.toISOString().slice(0, 10);
}

export function proximoDiaUtil(iso) {
  const d = new Date(iso); d.setDate(d.getDate() + 1);
  while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}

// Nome auto sugerido para novo projeto: "{empresa} · Melhorias · {data}"
// Phase 8.38 — usa locale ativo (pt-BR: DD/MM/AA, en-US: MM/DD/AA).
export function sugerirNomeProjeto(empresaNome, dataISO = null) {
  const d = dataISO ? new Date(dataISO) : new Date();
  const lng = i18n?.language || "pt-BR";
  const fmt = d.toLocaleDateString(lng, { day: "2-digit", month: "2-digit", year: "2-digit" });
  return `${empresaNome} · Melhorias · ${fmt}`;
}

// Re-export retrocompat: sites antigos ainda importam `fmtDataBR` daqui.
// Toda a lógica canônica vive em `@/lib/dateLocale`.
export { fmtDataBR } from "@/lib/dateLocale";
